/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unknown-property */
import React from 'react';
import Link from 'components/Link';
import s from './WeatherDayForecast.scss';
import { IMAGE_URL } from '../../../constants';

const WeatherDayForecast = ({ dayForecast, link, cityName, ga4Data }) => (
  <div className={`${s.weatherDayForecast}`}>
    <div className="boxWrap">
      {link &&
        cityName && (
          <Link
            to={link}
            ga4Data={ga4Data}
            className="fs12 mb12 flex flexAc uLine"
          >
            <i className="icon mr6 cityLocation" /> {cityName}
            <i className="icon ml8 rightArrow" />
          </Link>
        )}
      <div className="fs12 mb16">{dayForecast?.temperature?.time}</div>
      <section className={`${s.tepmWrap} flex flexAc mb8`}>
        <img
          className="mr12"
          src={`${IMAGE_URL}${dayForecast?.temperature?.icon}.cms`}
          alt={dayForecast?.temperature?.icon}
        />
        <span className="largeFont">
          {dayForecast?.temperature?.value}{' '}
          <sup>{dayForecast?.temperature?.unit}</sup>
        </span>
      </section>
      <section className="flex flexAc">
        <div className="flex flexAc">
          <span className="fs14 mr8">{dayForecast?.temperature?.phrase}</span>
          <span className="fs14">
            (Feels like {dayForecast?.feels_like?.value}
            {dayForecast?.feels_like?.unit})
          </span>
        </div>
        {/* <div className="vDivider mlr12" />
        <span className="fs12 flex flexAc">
          <i
            className={`icon mr4 ${
              dayForecast?.weather_overview?.rain_probability?.icon
            }`}
          />
          {dayForecast?.weather_overview?.rain_probability?.value}%
        </span> */}
      </section>
      <div className="hDivider mtb16" />
      <div className="fs12 hFont mb12">
        {dayForecast?.weather_overview?.name}
      </div>
      <section className={`${s.secItems} flex`}>
        {dayForecast?.weather_overview?.items &&
          Array.isArray(dayForecast?.weather_overview?.items) &&
          dayForecast?.weather_overview?.items.length &&
          dayForecast?.weather_overview?.items.map(item => (
            <div className={`${s.secItemCol} flex`}>
              <div className={s.iconWrap}>
                <i className={`icon ${item?.icon}`} />
              </div>
              <div className="fs12">
                <span className="mb8">{item?.name}</span>
                <div className={`${s.valueText} bold`}>
                  {item?.value} {item?.unit}
                  {item?.total ? ` of ${item?.total}` : ''}
                </div>
              </div>
            </div>
          ))}
      </section>
    </div>
  </div>
);

export default WeatherDayForecast;
